import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// Custom Styles
import "./AttachmentStyles.css";

export default function AttachmentDownload(props) {
    const [exists, setExists] = useState(true);
    const [loading, setLoading] = useState(true);
    const [name, setName] = useState(props.name);

    useEffect(() => {
        // Only check if a link is actually provided
        if (props.link) {
            fetch(props.link, { method: 'HEAD' })
                .then((res) => {
                    // res.ok is true if status is 200-299
                    if (!res.ok) {
                        setExists(false);
                    }
                })
                .catch(() => {
                    // If there's a network error or CORS issue, treat as missing
                    setExists(false);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [props.link]);

    useEffect(() => {
        if (!exists) {
            setName("Removed File ");
        }
    }, [exists])


    const openInNewTab = (url) => {
        window.open(url, '_blank', 'noreferrer');
    };

    const renderLink = () => {
        if (exists) return <Link to={props.link} target="_blank" download>Download<i class="fa-solid fa-download" /></Link>;
        return (
            <Link>Download <i class="fa-solid fa-download" /></Link>
        )
    }


    return (
        <div className='attachment-container'>
            <div className='attachment-control-display'>
                <h2 className='attachment-text header'>
                    {name + props.index} | {(props.size / 1024).toFixed(2)}kb
                </h2>
            </div>

            <div className='attachment-control-button'>
                <button onClick={() => {
                    if (exists) {
                        openInNewTab(props.link);
                    }
                }} className={exists ? 'remove-attachment-button approved-button'
                    : 'remove-attachment-button missing-attachment'}>View <i class="fa-solid fa-eye"></i></button>
            </div>

            <div className='attachment-control-button'>
                <button className={exists ? 'remove-attachment-button approved-button'
                    : 'remove-attachment-button missing-attachment'}>
                    {renderLink()}
                </button>
            </div>
        </div>
    )

}
